const lastCalled = {}

/**
 * allowAction - simple rate limiter per key
 * Returns true and records timestamp if action allowed (last call > wait)
 * Returns false if called too frequently
 * @param {string} key
 * @param {number} wait milliseconds
 */
export function allowAction(key, wait = 800) {
  const now = Date.now()
  const last = lastCalled[key] || 0
  if (now - last < wait) {
    return false
  }
  lastCalled[key] = now
  return true
}

export function resetAction(key) {
  delete lastCalled[key]
}
